// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bU70qfUvG6W0rLvrwMuM{position:relative}.bU70qfUvG6W0rLvrwMuM .notification-bar-wrapper{min-height:20px}.bU70qfUvG6W0rLvrwMuM .notification-bar-message{line-height:20px;margin-right:100px}.bU70qfUvG6W0rLvrwMuM .notification-bar-action{position:absolute;top:-5px;right:0}.bU70qfUvG6W0rLvrwMuM .notification-bar-action:hover{color:#dd4e44 !important;background-color:#fff !important}`, "",{"version":3,"sources":["webpack://./src/Containers/Notifications/Notifications.styl"],"names":[],"mappings":"AAEA,sBACI,iBAAS,CAET,gDACI,eAAY,CAEhB,gDACI,gBAAa,CACb,kBAAc,CAElB,+CACI,iBAAS,CAAU,QAAK,CAAM,OAAO,CAErC,qDACI,wBAAO,CACP,gCAAkB","sourcesContent":["@import '~assets/stylus/config/colors'\n    \n.Notifications\n    position relative\n\n    :global .notification-bar-wrapper\n        min-height: 20px;\n\n    :global .notification-bar-message\n        line-height: 20px;\n        margin-right: 100px;\n    \n    :global .notification-bar-action\n        position absolute; top: -5px; right: 0;\n\n        &:hover\n            color: colorRed !important;\n            background-color: #fff !important;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textColor": `#404041`,
	"colorRed": `#dd4e44`,
	"colorPink": `#ff1493`,
	"colorBlue": `#24b2e0`,
	"colorGreen": `#65c178`,
	"colorOrange": `#fa9961`,
	"colorYellow": `#e09f34`,
	"colorPurple": `#5841ab`,
	"colorDarkBlue": `#223c75`,
	"colorBrightBlue": `#3398d9`,
	"colorGoogle": `#4285f4`,
	"Notifications": `bU70qfUvG6W0rLvrwMuM`
};
export default ___CSS_LOADER_EXPORT___;
